import React, { Component } from "react";
import axios from "axios";
import "../components/Login.css";
import Errors from "../components/Input/Errors";
import Alerts from "./Alerts";
import TestVariable from "../variables/TestVariables";

axios.defaults.headers.common["Access-Control-Allow-Headers"] = "Content-Type";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

class Login2 extends Component {
  state = {
    username: window.UserP.username,
    password: window.UserP.password,
    user: "",
    validation: { required: false },
    searchresults: [],
    errors: [],
    errors2: "",
    valid: false,
  };

  handleClick = (e) => {
    const data1 = {
      username: this.state.username,
      password: this.state.password,
    };

    axios
      .post(window.UserP.url + "/LoginKS", data1)
      .then((response) => {
        const searchresults = response.data;

        this.setState({ searchresults });

        if (searchresults.Result === true) {
         
          window.UserP.PerdoruesID = searchresults.UsernameID;
          window.UserP.usernameKS = searchresults.UsernameKS;
          window.UserP.username = searchresults.Username;
          window.UserP.key = searchresults.ResultMessage;
          window.UserP.agencyId = searchresults.AgencyId;
          window.UserP.agency = searchresults.Agjensi;
          window.UserP.terminalId = searchresults.TerminalId;
          window.UserP.idProcesori = searchresults.IdProcesori;
          window.UserP.rol = searchresults.Rol;

          this.props.test("test-key", e, searchresults);

        
        } else {
          this.setState({ errors: searchresults.ResultMessage });
          this.changeInputColor();
        }
      })
      .catch((error) => {
   
        alert(error + " Ju lutem kontaktoni departamentin e IT!");
      });
  };
  checkValidity(value) {
    let isValid = false;
    if (value === "" && isValid) {
      isValid = true;
    }
    return isValid;
  }

  OnEnterPress = (e) => {
    if(e.keyCode === 13){
        this.handleClick(e);
        this.setState({
          NrPod:""
        })
    }
  };

  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };
  handleInputChange2 = (e) => {
    this.setState({
      password: e.target.value,
    });
  };

  changeInputColor = (e) => {
    document.getElementById("input2").style.borderColor = "red";
    document.getElementById("input1").style.borderColor = "red";
  };

  render() {
    return (
      <div>
        <div className="Form1">

            
          <div id="id" style={{ display: "flex", justifyContent: "center" }}>
            <div className="flex-md">               
            <h2
                className="text-primary"
                style={{ display: "flex", justifyContent: "center" ,fontSize: 35}}
              >Albanian Courier</h2>
             <h2
                className="text-primary"
                style={{ display: "flex", justifyContent: "center",fontSize: 25 }}
              >Programi Postar Agjent</h2>
              <br />
              <div className="ml-6">
                {" "}
                <h4
                className="text-primary"
                style={{ display: "flex", justifyContent: "center" }}
              >LOGIN</h4>
              </div>

              <div className="panel panel-default">
                {this.state.errors.length === 0 ? (
                  ""
                ) : (
                  <Errors errors={this.state.searchresults} />
                )}
                <input
                  id="input1"
                  className="form-control "
                  placeholder="Përdoruesi"
                  type="username"
                  required
                  name="username"
                  onKeyUp={this.OnEnterPress}
                  value={this.state.username}
                  onChange={(e) => this.handleInputChange(e, "username")}
                />
                {/* <TestVariable
                  changed={e => this.handleInputChange(e, "password")}
                  name={this.state.password}
                ></TestVariable> */}

                <input
                  id="input2"
                  className="form-control mt-4 "
                  type="password"
                  required
                  placeholder="Fjalëkalimi"
                  onChange={(e) => this.handleInputChange(e, "password")}
                  name="password"
                  onKeyUp={this.OnEnterPress}
                  value={this.state.password}
                />
              </div>
              <div className="panel panel-default">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mt-4"
                  onClick={(e) => this.handleClick(e)}
                >
                  {this.state.tagged ? "Tagged" : "Hyrje"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login2;



